import { Component, ViewChild } from '@angular/core';
import { CxWindow } from '@app-frame';
import { BenchmarkDashboardStorageService } from '../../benchmark-dashboard.storage.service';

@Component({
    selector: 'benchmark-dashboard-property-window',
    templateUrl: './dashbboard-properties.template.html',
    standalone: false
})
export class BenchmarkPropertyWindow {
    constructor(public storage : BenchmarkDashboardStorageService) {

    }


    @ViewChild(CxWindow, { static: true })
    public window: CxWindow;
}